<template>
  <ChecklistActivityListEmbeddable :activity-number="2" />
</template>
<script>
import ChecklistActivityListEmbeddable from "@/views/modules/checklist/ChecklistActivity/embeddable/ChecklistActivityListEmbeddable";

export default {
  components: {ChecklistActivityListEmbeddable},
  name: 'ChecklistActivity1',
}
</script>

